<template>
	<div>
		<!-- <template v-if="screenType !== 'mobile'">
      <BorderHorizontal :my="'my-1'" />
    </template> -->

		
		<SummaryRow
			:ratings="ratings"
			:globalRating="ssrReviewData.globalAverage"
			@setViewDetailClicked="handleSetViewDetailClicked"
		/>
		

		<BorderHorizontal v-if="screenType !== 'mobile'" :my="'my-1'" />

		<RatingsTotals
			v-if="viewDetailClicked"
			@setRatingsToShow="handleSetRatingsToShow"
		/>

		
		<Slider
			:reviewsArray="reviewsArray"
			@openAllReviews="state.seeAllPopupOpen = true"
		/>

		<PopupBase
			:open="state.seeAllPopupOpen"
			@closePopup="state.seeAllPopupOpen = !state.seeAllPopupOpen"
			:styleTop="'50px'"
		>
		
			<AllReviews
				@closePopup="state.seeAllPopupOpen = !state.seeAllPopupOpen"
			/>
		</PopupBase>

			<div
				class="d-none d-lg-flex w-100 my-3 cursor-pointer text-light-blue justify-content-end">
				<span @click.stop="state.seeAllPopupOpen = true" class="link-default">
					{{ content.liheReviews_seeReviews }}
					{{ ssrReviewData.reviewsSize }}
					{{ content.liheReviews_reviews }}
					<svg width="10" height="10" class="icon text-primary-blue">
						<use href="#___icon___chevron-right"></use>
					</svg>
				</span>
			</div>
		
	</div>
</template>

<script>
// README

import { mapState } from "vuex";

// components
import RatingsTotals from "@/vue/reviews/components/reviews/ratingsTotals.vue";
import SummaryRow from "@/vue/reviews/components/reviews/summaryRow.vue";
import Slider from "@/vue/reviews/components/reviews/slider.vue";
import ratingOrder from "@/config/ratingOrder";
import PopupBase from "@/vue/common/popupBase.vue";
import AllReviews from "@/vue/reviews/components/popups/allReviews/allReviews.vue";

import BorderHorizontal from "@/vue/common/borderHorizontal.vue";

export default {

	name: "Reviews",
	props: {},
	components: {
		RatingsTotals,
		SummaryRow,
		Slider,
		BorderHorizontal,
		PopupBase,
		AllReviews,
	},
	data() {
		return {
			data: {},
			state: {
				seeAllPopupOpen: false,
			},
		};
	},

	computed: {
		...mapState([
			"content",
			"ssrReviewData",
			"reviewsArray",
			"ratingsToShow",
			"viewDetailClicked",
			"screenType",
			"language",
		]),

		ratings() {
			return ratingOrder
				.map((ratingName) => {
					return {
						name: ratingName,
						rating: this.ssrReviewData[ratingName],
					};
				})
				.filter((_) => _);
		},
	},
	watch: {
		screenType(newType) {
		console.log('[ReviewsApp] screenType changed →', newType);
		}
    },

	methods: {
		handleSetViewDetailClicked() {
			this.$store.commit("setViewDetailClicked", !this.viewDetailClicked);
			if (!this.viewDetailClicked) {
				this.$store.commit("setRatingsToShow", null);
			}
		},

		handleSetRatingsToShow(e) {
			this.$store.commit("setRatingsToShow", e);
			console.log('[Reviews] ratingsToShow →', e)
		},

		// ?start=0&size=10&averageRatingMin=4&averageRatingMax=5&locale=fr-FR
	},
};
</script>

<style></style>
